export const FEATURE_FLAG_RESOURCE_UTILIZATION = 'enable_resource_utilization';

const FULL_UTILIZATION_PERCENT = 100;

type ResourceWithOrderCount = { order_count?: number | null };

export const getTotalOrdersCount = (resources: ResourceWithOrderCount[] = []): number =>
	resources.reduce((total, resource) => total + (resource.order_count ?? 0), 0);

export const isOverUtilized = (utilizationPercent?: number | null): boolean =>
	(utilizationPercent ?? 0) > FULL_UTILIZATION_PERCENT;

export const formatUtilizationPercent = (utilizationPercent: number): string => `${Math.round(utilizationPercent)}%`;
